import VueRouter from 'vue-router';

const routes = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "App" */ '../pages/App'),
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "App" */ '../pages/App/Board'),
            }
        ]
    },
    {
        path: '/access/:id/:url/:token',
        component: () => import(/* webpackChunkName: "Signin" */ '../pages/Access')
    },
    {
        path: '/profile',
        component: () => import(/* webpackChunkName: "Profile" */ '../pages/Profile'),
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "Profile" */ '../pages/Profile/Account'),
            },
            {
                path: 'apps',
                component: () => import(/* webpackChunkName: "Profile" */ '../pages/Profile/App'),
            },
            {
                path: 'settings',
                component: () => import(/* webpackChunkName: "Profile" */ '../pages/Profile/Settings'),
            },
            {
                path: 'privacy',
                component: () => import(/* webpackChunkName: "Profile" */ '../pages/Profile/Privacy'),
            },
            {
                path: 'certificate',
                component: () => import(/* webpackChunkName: "Profile" */ '../pages/Profile/Certificate'),
            }
        ]
    },
    {
        path: '/user/:id',
        component: () => import(/* webpackChunkName: "Profile" */ '../pages/User'),
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "Profile" */ '../pages/User/Main'),
            },
            {
                path: 'apps',
                component: () => import(/* webpackChunkName: "Profile" */ '../pages/Profile/App'),
            },
            {
                path: 'settings',
                component: () => import(/* webpackChunkName: "Profile" */ '../pages/Profile/Settings'),
            },
            {
                path: 'privacy',
                component: () => import(/* webpackChunkName: "Profile" */ '../pages/Profile/Privacy'),
            }
        ]
    },
    {
        path: '/admin',
        component: () => import(/* webpackChunkName: "Admin" */ '../pages/Admin'),
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "Admin" */ '../pages/Admin/Dashboard'),
            },
            {
                path: 'app',
                component: () => import(/* webpackChunkName: "Admin" */ '../pages/Admin/Apps'),
            },
            {
                path: 'app/create',
                component: () => import(/* webpackChunkName: "Admin" */ '../pages/Admin/AppCreate'),
            },
            {
                path: 'app/:id',
                component: () => import(/* webpackChunkName: "Admin" */ '../pages/Admin/App'),
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "Admin" */ '../pages/Admin/App/Global'),
                    },
                    {
                        path: 'config',
                        component: () => import(/* webpackChunkName: "Admin" */ '../pages/Admin/App/Config'),
                    },
                    {
                        path: 'users',
                        component: () => import(/* webpackChunkName: "Admin" */ '../pages/Admin/App/Users'),
                    }
                ]
            },
            {
                path: 'confidentiality',
                component: () => import(/* webpackChunkName: "Admin" */ '../pages/Admin/Confidentiality'),
            },
            {
                path: 'confidentiality/create',
                component: () => import(/* webpackChunkName: "Admin" */ '../pages/Admin/ConfidentialityCreate'),
            }
        ]
    },
    {
        path: '*',
        component: () => import(/* webpackChunkName: "Signin" */ '../pages/NotFound')
    }
]

export default new VueRouter({
    mode: 'history',
    routes
})



// WEBPACK FOOTER //
// ./src/router/index.js